{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CSGO Mines",
  "alternateName": [
    "cs mines", "csgo mines", "минер игра кс"
  ],
  "description": "Игра, где игрок выбирает клетки и избегает мин, чтобы выиграть награды.",
  "url": "https://6cs.fail/ru/mines"
}
